import React from "react";
import { useQuery } from "@apollo/client";
import { HOME_PAGE_FAKES_LIST } from "src/queries";
import { IMAGE_BASE_URL } from "src/utils/constants";
import { useTranslation } from "react-i18next";

const UserList = ({ user }) => {
  //https://globalchat.us/media/unsafe_flag.jpg

  let image = IMAGE_BASE_URL + user.profilePic;
  if (user.profilePic == "unsafe_flag.jpg") {
    image = IMAGE_BASE_URL + user.photos[0].image;
  }
  return (
    <div className="flex flex-col items-center lg:flex-row lg:items-center">
      <img className="object-cover w-40 h-40 rounded-full" src={image} alt="" />
      <p className="mt-4 font-semibold lg:mt-0 lg:ml-6 truncate max-w-xs">
        {/* {user.base_profile.firstName} */}
        {user.username}
      </p>
    </div>
  );
};

const MultiUser = () => {
  const { t } = useTranslation();
  const { loading, data } = useQuery(HOME_PAGE_FAKES_LIST);

  // console.log(data.getRandomUsersHome,"datadatadatadatadata")

  if (loading) return;
  if (!data) return;

  return (
    <main className="relative">
      <section className="bg-white relative overflow-hidden">
        <div className="py-10 mx-auto">
          <div className="bg-black h-[150px] flex items-center gap-20 px-6">
            <div>
              <h1 className="text-3xl font-semibold text-[#FF005C]">
               {t("ONLINE")} <br /> {t("USERS")}
              </h1>
              <button className="text-sm mt-4 bg-white sm:text-base rounded-full font-medium px-4 py-1 sm:py-1.5 sm:px-5">
                {t("REFRESH")}
              </button>
            </div>
            <div className="flex justify-center items-center  space-x-6 text-white">
              <div className="flex flex-col items-center hidden md:flex space-y-1">
                <div className="w-[4px] h-[4px] bg-white rounded-full"></div>
                <div className="w-[4px] h-[4px] bg-white rounded-full"></div>
                <div className="w-[4px] h-[4px] bg-white rounded-full"></div>
                <div className="w-[4px] h-[4px] bg-white rounded-full"></div>
                <div className="w-[4px] h-[4px] bg-white rounded-full"></div>
                <div className="w-[4px] h-[4px] bg-white rounded-full"></div>
                <div className="w-[4px] h-[4px] bg-white rounded-full"></div>
              </div>
              <p className="text-center hidden md:flex  text-lg font-semibold">
                {t("Join")}
              </p>
            </div>
          </div>
          <section className="max-w-[1000px] mx-auto px-6 pb-20">
            <div className="grid grid-cols-1 gap-6 md:gap-10 mt-8 md:mt-12 md:grid-cols-2 lg:grid-cols-3">
              {data.getRandomUsersHome.map((user) => {
                return <UserList user={user} />;
              })}
            </div>
          </section>
        </div>

        {/* Top Right Curves */}

        <div className="absolute top-4 right-4 transform translate-x-1/2 -translate-y-1/4">
          <div className="relative w-40 h-40">
            <div className="absolute top-12 left-12 w-16 h-16 border-4 border-white rounded-full"></div>
            <div className="absolute top-8 left-8 w-24 h-24 border-4 border-white rounded-full"></div>
            <div className="absolute top-4 left-4 w-32 h-32 border-4 border-white rounded-full"></div>
            <div className="absolute top-0 left-0 w-40 h-40 border-4 border-white rounded-full"></div>
          </div>
        </div>

        <div className="absolute bottom-4 left-4 transform -translate-x-1/2 translate-y-1/2">
          <div className="relative w-40 h-40">
            <div className="absolute bottom-12 right-12 w-16 h-16 border-4 border-black rounded-full"></div>
            <div className="absolute bottom-8 right-8 w-24 h-24 border-4 border-black rounded-full"></div>
            <div className="absolute bottom-4 right-4 w-32 h-32 border-4 border-black rounded-full"></div>
            <div className="absolute bottom-0 right-0 w-40 h-40 border-4 border-black rounded-full"></div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MultiUser;
